import { render, staticRenderFns } from "./GlobalNotice.vue?vue&type=template&id=7854e619&"
import script from "./GlobalNotice.vue?vue&type=script&lang=js&"
export * from "./GlobalNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports